import { textConstants } from '../constants/text.constants';

export function text(state = {}, action) {
  switch (action.type) {
    case textConstants.UPDATE_REQUEST:
    case textConstants.FETCH_REQUEST:    
    case textConstants.GET_REQUEST:
      return {
        ...state,
        loading: true
      };    
    case textConstants.GET_SUCCESS:
    case textConstants.UPDATE_SUCCESS:
    return{
      ...state,
      item: action.text,
      loading: false
    }    
    case textConstants.FETCH_SUCCESS:      
      return {
        ...state,
        texts: action.texts,
        loading: false
      };
    case textConstants.FETCH_FAILURE:
    case textConstants.GET_FAILURE:
    case textConstants.UPDATE_FAILURE:
      return {
        ...state,
        error: action.error
      };   
    default:
      return state
  }
}
